import { errorGraphQL } from 'analytics/utilities';
import { notifyBugsnagClient } from 'components/error/bugsnag';
import {
  createClient,
  fetchExchange,
  errorExchange,
} from 'urql';
import { devtoolsExchange } from '@urql/devtools';
import { cacheExchange } from '@urql/exchange-graphcache';
import { getLocalToken } from 'utilities/auth/sessionToken';
import {
  getGraphqlUrl,
  extractConfigurationFromUrl
} from 'utilities/integration/rails';
import SEGMENT from 'constants/segment';
import env from 'utilities/env';
import * as Castle from '@castleio/castle-js';
import { getAdminUserID } from 'utilities/auth/adminUserId';
import { adminTokenHeaders } from 'utilities/auth/adminToken';
import queryResolvers from '../paginationResolvers';
import * as mutationCacheUpdates from './updates/mutation/cacheUpdates';
import { qaExchange, alertExchange } from './exchanges';

extractConfigurationFromUrl(document.location.search);

const onError = (combinedError) => {
  notifyBugsnagClient(combinedError);
  errorGraphQL(SEGMENT.ERROR)(
    { label: SEGMENT.TYPES.GRAPHQL_ERROR },
    combinedError
  );
};

const exchanges = [
  ...(env('NODE_ENV') === 'development' ? [devtoolsExchange] : []),
  errorExchange({ onError }),
  cacheExchange({
    resolvers: queryResolvers,
    updates: {
      Mutation: mutationCacheUpdates
      // Subscription: subscriptionCacheUpdates
    },
    keys: {
      /**
       *  @todo instead of using a custom key we'd like to add an
       *        ID to the CommunicationChannel model
       *        For now this is to prevent urql complaining about duplicate keys
       *        https://formidable.com/open-source/urql/docs/graphcache/normalized-caching/#custom-keys-and-non-keyable-entities
       * */
      CommunicationChannel: data => data.event,
      // Has no id: the same background check can have a different status on another job request
      BackgroundCheckRequirement: () => null,
    },
  }),
  ...(env('QA_URQL_EXCHANGE') ? [qaExchange] : []),
  alertExchange,
  fetchExchange,
];

const client = createClient({
  url: getGraphqlUrl(),
  fetch: async (url, options) => {
    const sessionToken = getLocalToken();

    const defaultHeaders = {
      Cookie: document.cookie,
      'X-Token': sessionToken,
      'Admin-User-Id': getAdminUserID(),
      ...adminTokenHeaders(),
    };
    const castleToken = await Castle.createRequestToken();
    return fetch(url, {
      ...options,
      headers: {
        ...options.headers,
        ...defaultHeaders,
        'X-Castle-Request-Token': castleToken
      }
    });
  },
  exchanges,
});

export default client;
